import { CloseOutlined, SettingOutlined } from "@ant-design/icons"
import { Modal, Select, TreeSelect } from "antd"
import '../../style.scss'

import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { NodataTable } from "../../../../../components/NoDataTable";
import { getListCarCompany, getSLUnitOption, ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi";
import { CustomLoadingOverlayTable, dataPagination, fommatSelectOption, fommatSelectOptionUnit, formatPrice } from "../../../../../until";
import { IDataFilterGroupList, IPagination } from "../AddGroup/AddNewGroup";
import useThrottle from "../../../../../hook/useThrottle";
import { useCustomerGroupContext } from "../../indexV2";
import { formatNumber } from "../../../../../services/mixin";

dayjs.locale('vi');

interface ModalProps {
  loadingTableModal: boolean
  isOpen: boolean
  dataFilterListCondUnmatchedCustomers: IDataFilterGroupList
  memoizedColumnDefs: ColDef<any, any>[];
  tableDataCondUnmatchedCustomers: any[];
  paginationCondUnmatchedCustomers: IPagination;

  selectedIdCondUnmatchedCustomers: Set<number>
  setSelectedIdCondUnmatchedCustomers: (data: Set<number>) => void;
  setDataFilterListCondUnmatchedCustomers: (dataFilterList: IDataFilterGroupList) => void;
  onPaginationCondUnmatchedCustomers: (page: number, pageSize: number) => void;

  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: (e: boolean) => void

}


const ModalAddCustomersManually: React.FC<ModalProps> = ({
  loadingTableModal,
  isOpen,
  dataFilterListCondUnmatchedCustomers,
  memoizedColumnDefs, tableDataCondUnmatchedCustomers, paginationCondUnmatchedCustomers,
  selectedIdCondUnmatchedCustomers,
  setSelectedIdCondUnmatchedCustomers, setDataFilterListCondUnmatchedCustomers, onPaginationCondUnmatchedCustomers,
  onSubmitFormModal, closeModal
}) => {
  const {
    // sLUnit, sLCategoryCar,
    sLCategoryCar, sLNationwide
  } = useCustomerGroupContext();


  const isRestoringSelection = useRef(false);
  const gridApiRef = useRef<GridApi | null>(null);

  const [selectedIdCondUnmatchedCustomersTmp, setSelectedIdUnmatchedCustomersTmp] = useState<Set<number>>(new Set());

  //------------------------------------
  // Định danh duy nhất cho mỗi row
  const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

  // --- Grid ready ---
  const onGridReady = useCallback((params: { api: GridApi }) => {
    gridApiRef.current = params.api;
  }, []);

  // --- Selection change ---
  const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
    if (isRestoringSelection.current) return;
    const api = event.api;
    const selectedNodes = api.getSelectedNodes().filter(n => n.data);
    const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

    const currentPageIds = (tableDataCondUnmatchedCustomers ?? []).map((row: any) => Number(row.id));

    // --- Tạo bản sao của selectedIds hiện tại ---
    const nextSet = new Set(selectedIdCondUnmatchedCustomersTmp);

    // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
    const added: Number[] = [];
    const removed: Number[] = [];

    // Kiểm tra từng ID trên trang hiện tại
    for (const id of currentPageIds) {
      const isCurrentlySelected = selectedIdsOnPage.includes(id);
      const wasPreviouslySelected = selectedIdCondUnmatchedCustomersTmp.has(id);

      if (isCurrentlySelected && !wasPreviouslySelected) {
        // ID mới được chọn
        added.push(id);
        nextSet.add(id);
      } else if (!isCurrentlySelected && wasPreviouslySelected) {
        // ID bị bỏ chọn
        removed.push(id);
        nextSet.delete(id);
      }
    }


    setSelectedIdUnmatchedCustomersTmp(nextSet);
  }, [selectedIdCondUnmatchedCustomersTmp, tableDataCondUnmatchedCustomers]);
  //------------------------------------


  // --- Khôi phục selection khi data mới load ---
  useEffect(() => {
    if (gridApiRef.current && tableDataCondUnmatchedCustomers && tableDataCondUnmatchedCustomers.length > 0) {
      isRestoringSelection.current = true;

      gridApiRef.current.forEachNode((node: any) => {
        if (node.data && selectedIdCondUnmatchedCustomersTmp.has(Number(node.data.id))) {
          node.setSelected(true, false, true);
        } else {
          node.setSelected(false, false, true);
        }
      });

      setTimeout(() => {
        isRestoringSelection.current = false;
      }, 0);
    }
  }, [tableDataCondUnmatchedCustomers, selectedIdCondUnmatchedCustomersTmp]);

  // --- Khôi phục selection khi data mới load ---


  const handleAddCustomer = useThrottle(() => {
    setSelectedIdCondUnmatchedCustomers(selectedIdCondUnmatchedCustomersTmp)
    closeModal(false)
  }, 1000)

  useEffect(() => {
    if (isOpen) {
      setSelectedIdUnmatchedCustomersTmp(selectedIdCondUnmatchedCustomers)
    } else {
      setSelectedIdUnmatchedCustomersTmp(new Set())
    }
  }, [isOpen]);

  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className=" custom-page-css text-344054 text-lg  font-medium">Thêm khách hàng thủ công</span>
        <CloseOutlined className="text-base text-8B8B8B"
          onClick={() => closeModal(false)}
        />
      </div>}
      open={isOpen}
      onCancel={() => closeModal(false)}
      centered
      className="w-modal-V2 custom-page-css overflow-hidden modal-content-addCustomer ant-modal-size rounded"
      closeIcon={false}
      footer={
        <div className="custom-page-css w-full flex items-center justify-end h-auto py-2 px-4">
          <div className={`  bg-096DD9 border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-4 cursor-pointer`}
            onClick={handleAddCustomer}
          >
            <span className={` custom-page-css text-white text-base  font-regular`}>Thêm khách hàng vào nhóm</span>
          </div>

        </div>
      }
    >
      <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">

        {/* Filters */}
        <div className="custom-page-css flex items-start gap-2">
          <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
            <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
              <div className="d-flex align-center w-full">

                <TreeSelect
                  className="w-full text-left text-span-select custom-input-focus text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"

                  multiple
                  showSearch
                  placeholder="Chọn đơn vị"
                  allowClear
                  value={dataFilterListCondUnmatchedCustomers?.listUnit}
                  treeDefaultExpandAll={false}
                  treeData={sLNationwide}
                  filterTreeNode={(input: string, option: any) =>
                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => setDataFilterListCondUnmatchedCustomers({ ...dataFilterListCondUnmatchedCustomers, listUnit: e })}
                />
              </div>
            </div>
          </div>

          <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
            <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
              <div className="d-flex align-center w-full">
                <Select
                  showSearch={false}
                  allowClear
                  mode="multiple"
                  className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                  popupClassName="position-dropdow custome-select-item h-popUp"
                  variant="borderless"
                  placeholder="Thương hiệu"
                  options={sLCategoryCar}
                  value={dataFilterListCondUnmatchedCustomers?.listCategoryCar}
                  onChange={(e) => setDataFilterListCondUnmatchedCustomers({ ...dataFilterListCondUnmatchedCustomers, listCategoryCar: e })}
                />
              </div>
            </div>
          </div>
          <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
            <Input
              placeholder="Tìm kiếm thông tin khách hàng"
              className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
              value={dataFilterListCondUnmatchedCustomers.search}
              onChange={(e) => setDataFilterListCondUnmatchedCustomers({ ...dataFilterListCondUnmatchedCustomers, search: e.target.value })}
            />
            <div className="border-l-F2F4F7 h-full d-flex align-center">
              <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
            </div>
          </div>
        </div>



        <div className="custom-page-css flex items-center justify-betweeen gap-1">
          <div className="custom-page-css flex items-center gap-1">
            <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
            <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(selectedIdCondUnmatchedCustomersTmp.size)} khách hàng</span>
          </div>
          {/* <div className="custom-page-css flex items-center justify-end gap-2">
            <div className="btn-input t-px-8 cursor-pointer"
              onClick={handleOpenDataFields}
            >
              <div className="icon-svg">
                <SettingOutlined />
              </div>
            </div>
          </div> */}
        </div>

        <div className="ag-theme-alpine custom-table-ag custom-h-modal" style={{ height: 550, width: '100%' }}>
          <AgGridReact
            // domLayout="autoHeight"
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            columnDefs={memoizedColumnDefs}
            rowData={tableDataCondUnmatchedCustomers}
            rowHeight={55}
            defaultColDef={{
              resizable: true
            }}
            loading={loadingTableModal}
            loadingOverlayComponent={CustomLoadingOverlayTable}
            overlayNoRowsTemplate={NodataTable}
            rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
            getRowId={getRowId}
            onGridReady={onGridReady}
            onSelectionChanged={onSelectionChanged}
          />
        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={paginationCondUnmatchedCustomers.current}
              pageSize={paginationCondUnmatchedCustomers.pageSize}
              total={paginationCondUnmatchedCustomers.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(paginationCondUnmatchedCustomers.total, paginationCondUnmatchedCustomers.pageSize, paginationCondUnmatchedCustomers.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationCondUnmatchedCustomers}
            />
          </div>
        </ConfigProvider>
      </div>
    </Modal >
  )
}
export default ModalAddCustomersManually
